import React, { useContext } from 'react';
import { Box, Button, ChevronLeftIcon, HStack, Link } from 'native-base';
import { NavigationContext } from '../../../contexts';
const LeadSubmit = () => {
  const {
    createLead,
    type,
    logUserEvent,
    isApiLoading
  } = useContext(NavigationContext);
  const handleSubmit = () => {
    logUserEvent({
      type,
      action: `${type}ReviewSubmitClicked`
    });
    createLead(true);
  };
  return /*#__PURE__*/React.createElement(Button, {
    variant: "freedom",
    w: "140",
    _text: {
      fontWeight: 'bold',
      fontSize: 'lg'
    },
    accessibilityRole: "button",
    accessibilityLabel: "submit",
    onPress: handleSubmit,
    isDisabled: isApiLoading,
    isLoading: isApiLoading,
    _disabled: {
      bg: 'grey.200'
    },
    testID: 'footer-submit-button'
  }, "Submit");
};
const Footer = _ref => {
  let {
    navigation: {
      back,
      next
    },
    isLastScreen,
    selectedValue,
    valueKey,
    onNextEvent,
    onBackEvent,
    onNext
  } = _ref;
  const {
    setStep,
    logUserEvent,
    type,
    total
  } = useContext(NavigationContext);
  return /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    w: "100%",
    display: "flex",
    mt: "54"
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "center",
    alignItems: "center",
    space: "1"
  }, total !== 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    color: "blue.400",
    size: "5"
  })), /*#__PURE__*/React.createElement(Link, {
    onPress: () => {
      if (isLastScreen) {
        logUserEvent({
          type,
          action: `${type}ReviewBackClicked`
        });
      } else {
        logUserEvent({
          type,
          action: onBackEvent
        });
      }
      setStep(back);
    },
    accessibilityLabel: "back",
    accessibilityRole: "link",
    _text: {
      fontSize: 'lg',
      color: 'blue.400',
      textDecoration: 'none'
    },
    testID: 'footer-back-button'
  }, "Back")) : null), !isLastScreen ? /*#__PURE__*/React.createElement(Button, {
    variant: "freedom",
    w: "140",
    _text: {
      fontWeight: 'bold',
      fontSize: 'lg'
    },
    accessibilityRole: "button",
    accessibilityLabel: "next",
    onPress: () => {
      logUserEvent({
        type,
        action: onNextEvent
      });
      onNext({
        value: {
          [valueKey]: selectedValue
        },
        navigation: {
          action: 'next',
          back: back,
          next: next
        }
      });
    },
    isDisabled: !isLastScreen && selectedValue === 0,
    _disabled: {
      bg: 'grey.200'
    },
    testID: 'footer-next-button'
  }, "Next") : /*#__PURE__*/React.createElement(LeadSubmit, null));
};
export default Footer;
//# sourceMappingURL=index.js.map